import localStore from "./store.local";
import firebaseStore from "./store.firebase";

export function getStoreMode() {
  const raw = import.meta.env.VITE_STORE_MODE || "local";
  return String(raw).toLowerCase() === "firebase" ? "firebase" : "local";
}

const store = getStoreMode() === "firebase" ? firebaseStore : localStore;

export default store;
